import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { handleLogin as apiLogin } from '../utils/api-handlers/authentication-forms';
import NewAdminAuthService from '../services/admin-auth-service';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const Navigate = useNavigate();

  const targetPageIsProtected = !(/^\/(?:forgot-password|resetpkey\/[^\/]+)$/.test(location?.pathname))

  useEffect(() => {
    // 驗證使用者身份的函數
    const validateToken = async (retryCount = 0) => {
      // 確保只在客戶端執行
      if (typeof window !== 'undefined') {
        const token = localStorage.getItem('biodnd_admin_token');
        
        if (!token) {
          localStorage.clear();
          setLoading(false);
          setIsAuthenticated(false);
          setUser(null);
          if (location?.pathname !== "/login") {
            if (targetPageIsProtected) {
              Navigate("/login");
            }  
          }
          return;
        }
        
        try {
          const response = await NewAdminAuthService.getProfile();
          localStorage.setItem('biodnd_admin_token', JSON.stringify(response.data));
          setUser(response.data);
          setIsAuthenticated(true);
        } catch (error) {
          console.error('驗證失敗:', error);
          if (error?.response?.status === 401 || error?.response?.status === 403) {
            localStorage.clear();
            setLoading(false);
            setIsAuthenticated(false);
            setUser(null);
            if (location?.pathname !== "/login") {
              if (targetPageIsProtected) {
                Navigate("/login");
              }  
            }
          }
        } finally {
          setLoading(false);
        }
      }
    };

    validateToken();
  }, [location]);

  const login = async (username, password) => {
    try {
      const result = await apiLogin(username, password);
      
      if (result?.token) {
        localStorage.setItem('biodnd_admin_token', JSON.stringify(result));
        setUser(result);
        setIsAuthenticated(true);
        return { success: true, data: result };
      }
      return { success: false };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error };
    }
  };

  const logout = () => {
    localStorage.clear();
    setLoading(false);
    setIsAuthenticated(false);
    setUser(null);
    Navigate("/login");
  };

  const value = {
    isAuthenticated,
    user,
    login,
    logout,
    loading
  };

  if (loading) {
    return <div>Loading...</div>; // 或其他載入畫面
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};